import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TableControlService {

  readonly refreshTableConfig: WritableSignal<boolean> = signal(false);
  readonly refreshTableData: WritableSignal<boolean> = signal(false);
  readonly clearTableFilters: WritableSignal<boolean> = signal(false);
  readonly clearState: WritableSignal<boolean> = signal(false);
  readonly unselectTableRows: WritableSignal<boolean> = signal(false);

  constructor() { }

}
